<!-- app.component.html -->
<app-preloader *ngIf="loading" [progress]="progress"></app-preloader>

<ng-container *ngIf="!loading">
  <!-- Non authentifié -->
  <app-navbar *ngIf="!authService.isAuthenticated()"></app-navbar>

  <!-- Authentifié -->
  <ng-container *ngIf="authService.value">
    <app-buyer-navbar *ngIf="isBuyer"></app-buyer-navbar>
    <app-supplier-navbar *ngIf="isSupplier"></app-supplier-navbar>
    <app-organisme-navbar *ngIf="isOrganisme"></app-organisme-navbar>
  </ng-container>

  <router-outlet></router-outlet>

  <app-footer></app-footer>
</ng-container>